// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"a3e55497","586":"d8fd209e","616":"bcc81a7a","700":"04d06363","758":"1950e83e"}[chunkId] + ".chunk.js";
};